import {useTranslation} from "react-i18next"
import {useLexiconsContext} from "../../reactContext/contextCustomHooks/useLexiconsContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {toast} from "react-toastify"
import isLicenceValidity from "../../tools/isLicenceValidity"

export default function AddLexiconBtn() {
    const {t} = useTranslation()
    const {setLexiconsAction} = useLexiconsContext()
    const {teamContext} = useTeamContext()

    const handleClick = () => {
        if (isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate)) {
            setLexiconsAction({type: "IS_MODAL", payload: {isModal: true, modalType: "input"}})
        } else {
            toast.error(t("Licence expired. Please contact Neurowide sales department."))
        }
    }

    return (
        <>
        <button className="add-lexicon-btn" onClick={handleClick} title={t("Create a lexicon")}>{t("Create a lexicon")}</button>
        </>
    )
}